import { Type } from '@angular/core';
import { FilingLoaderMode } from '../../../../environments/environment.types';
import { FilingLoadOverlayComponent } from '../../../components/common/filing-load-overlay/filing-load-overlay.component';
import { BlockingOverlayFilingLoaderStrategy } from './blocking-overlay-filing-loader.strategy';
import { FilingLoaderStrategy } from './filing-loader.strategy';
import { NoOpFilingLoaderStrategy } from './no-op-filing-loader.strategy';

/**
 * Pairs a strategy class with its optional UI component.
 *
 * `ui: null` means the variant renders nothing at the page level — the
 * `'skeleton'` mode is the canonical example (per-sheet spinners drive the
 * visible UX instead, via `ConversionProgressService`).
 */
export interface FilingLoaderVariant {
  readonly strategy: Type<FilingLoaderStrategy>;
  readonly ui: Type<unknown> | null;
}

/**
 * Registry of every filing-form loader variant. Adding a new variant:
 *
 *   1. Extend the `FilingLoaderMode` union in `environment.types.ts`.
 *   2. Implement a new `FilingLoaderStrategy` subclass.
 *   3. (Optional) Build a matching UI component.
 *   4. Add an entry here mapping the mode literal to the pair.
 *
 * Existing variants are not modified — this is the OCP seam.
 *
 * @see docs/ui/loaders/filing/adding-a-new-loader-variant.md
 */
export const FILING_LOADER_VARIANTS: Record<FilingLoaderMode, FilingLoaderVariant> = {
  skeleton: {
    strategy: NoOpFilingLoaderStrategy,
    ui: null,
  },
  blocking: {
    strategy: BlockingOverlayFilingLoaderStrategy,
    ui: FilingLoadOverlayComponent,
  },
};
